import { Pipe, PipeTransform } from '@angular/core';
import { InstrumentType, SavingsPlan } from '@zero/shared/util-models';

@Pipe({
  name: 'hasCrypto',
  standalone: true,
})
export class HasCryptoPipe implements PipeTransform {
  public transform(savingsPlans: SavingsPlan[]): boolean {
    return !!savingsPlans?.some((plan) => plan.instrumentType === InstrumentType.Crypto);
  }
}
